import React, { useState, useCallback } from 'react';
import BoxBreathingCanvas from './boxBreathingcanvas';
import InfoPanel from './InfoPanel';
import './boxbreathing.css';
import Breathing from './flower.png';

export default function BoxBreathing() {
  const [started, setStarted] = useState(false);
  const [paused, setPaused] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  const handleStart = useCallback(() => {
    setStarted(true);
    setPaused(false);
  }, []);

  const togglePause = useCallback(() => {
    setPaused(prev => !prev);
  }, []);

  const handleReset = useCallback(() => {
    setStarted(false);
    setPaused(false);
  }, []);

  const toggleInfo = useCallback(() => {
    setShowInfo(prev => !prev);
  }, []);

  return (
    <div className="box-breathing-container">
      <div className="hero-section-1">
        <img 
          src={Breathing} 
          alt="Peaceful meditation scene" 
          className="hero-image" 
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="content-section">
        {!started ? (
          <div className="welcome-screen">
            <h1>Box Breathing</h1>
            <p className="subtitle">A technique to reduce stress and improve focus</p>
            <div className="button-row">
              <button 
                className="primary-button"
                onClick={handleStart}
              >
                Begin Practice
              </button>
              
              <button 
                className="info-button"
                onClick={toggleInfo}
              >
                Learn More
              </button>
            </div>
          </div>
        ) : (
          <div className="practice-screen">
            
            <div className="canvas-container">
              <BoxBreathingCanvas paused={paused} />
            </div>
            
            <div className="controls">
              <button
                className={`control-button ${paused ? 'resume' : 'pause'}`}
                onClick={togglePause}
              >
                {paused ? 'Resume' : 'Pause'}
              </button>
              <button
                className="control-button reset"
                onClick={handleReset}
              >
                Reset
              </button>
            </div>
          </div>
        )}
      </div>
      
      {showInfo && <InfoPanel onClose={toggleInfo} />}
    </div>
  );
}